import api from "./api";

const balanceService = {
    getBalanceOfToken: (jwttoken, idActiveToken) =>
        api.get(`/balanceGpxcoin/${idActiveToken}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getBalanceOfGpx: (jwttoken) =>
        api.get(`/balanceGpxcoin`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
};

export default balanceService;